import React, { lazy, Component, Suspense } from "react";
import autoBind from "auto-bind";
import axios from "axios";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import isEqual from "lodash/isEqual";
import i18next from "i18next";
import { toast } from "react-toastify";
import { IBILoader } from "./components/UIComponents/IBILoader";
import { ToastNotification, showToast } from "./components/DesignSystem/Toast";
import { CenterContent } from "components/DesignSystem/GlobalStyle";
import { timedErrorPopUp } from "components/commonUtilities";
import { isPathPublicViewer } from "./Utilities/generalUtilities";
import { dynamicModuleNames, isLocalEnvironment, getBackendBaseUrl } from "./constants";
import { getCurrentCity } from "actions/City";

export const globalDict = {};

const Main = lazy(() => import("./components/Main"));

class App extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.origin = getBackendBaseUrl();
        this.state = { isCityDataLoaded: false };
    }

    updateSize() {
        if (document.getElementsByClassName("app-body")[0]) {
            document.getElementsByClassName("app-body")[0].style.height = `${window.innerHeight}px`;
        }
    }

    render() {
        const { isCityDataLoaded } = this.state;

        return (
            <>
                {isCityDataLoaded ? (
                    <Suspense fallback={IBILoader}>
                        <ToastNotification />
                        <Main />
                    </Suspense>
                ) : (
                    <CenterContent className="w-100">
                        <IBILoader />
                    </CenterContent>
                )}
            </>
        );
    }

    setupLocalEnvironment() {
        const { t } = this.props;
        try {
            const baseURL = process.env.REACT_APP_BASE_URL;
            const authToken = process.env.REACT_APP_AUTH_TOKEN;

            if (!baseURL || !authToken) {
                alert(t("Please include baseURL and AuthToken in LocalSettings"));
                return;
            }

            axios.defaults.baseURL = baseURL;
            axios.defaults.headers.common.Authorization = authToken;

            this.setState({ isCityDataLoaded: true });
            localStorage.setItem("isUserAuthenticated", "true");
        } catch (error) {
            alert(t("Please include LocalSettings file"));
            timedErrorPopUp(error);
            console.error(error);
        }
    }

    componentDidUpdate(prevProps) {
        const { isCurrentCityReceived, cityConfig } = this.props;

        if (prevProps.isCurrentCityReceived !== isCurrentCityReceived && isCurrentCityReceived) {
            if (localStorage.getItem("termsAndConditionsAgreed") === null) {
                localStorage.setItem("termsAndConditionsAgreed", "false");
            }

            if (isLocalEnvironment) {
                this.setupLocalEnvironment();
            }
        }

        // Handle city config changes
        if (!isEqual(prevProps.cityConfig, cityConfig)) {
            if (isLocalEnvironment) {
                return;
            }
            if (
                isPathPublicViewer() ||
                (this.props.currentCity.modules_enabled.includes(dynamicModuleNames.pfcv) &&
                    window.location.pathname === "/")
            ) {
                //TODO: handle in authorisation
                localStorage.setItem("isUserAuthenticated", "true");
            }
            this.setState({ isCityDataLoaded: true });
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateSize);
        this.updateSize();

        // Reload if a cached page is served
        window.addEventListener("pageshow", (event) => {
            if (event.persisted) {
                window.location.reload();
            }
        });

        window.addEventListener("offline", () => {
            showToast(
                i18next.t(
                    "Network connection is unavailable. Please check your internet connection and try again."
                ),
                {
                    autoClose: 5000,
                    toastId: "network-toast",
                    type: "error"
                }
            );
            window.isOnline = false;
        });

        window.addEventListener("online", () => {
            window.isOnline = true;
            toast.dismiss("network-toast");
        });

        window.addEventListener("load", () => {
            window.isOnline = true;
        });

        if (isLocalEnvironment) {
            this.setupLocalEnvironment();
        } else {
            axios.defaults.withCredentials = true;
            axios.defaults.baseURL = this.origin;
        }
        this.props.getCurrentCity();
    }
}

const mapStateToProps = (state) => {
    const { city } = state;

    return {
        isCurrentCityReceived: city.isCurrentCityReceived,
        currentCity: city.currentCity,
        cityConfig: city.cityConfig
    };
};

const mapDispatchToProps = {
    getCurrentCity
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(App));
